import { RadioboxBlankIcon } from './RadioboxBlankIcon';

/**
 * author: Google
 * id 10BF2326-3190-4C27-9040-E2F8F4961238
 * name radiobox-blank
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/radiobox-blank.svg
 * tags
 * - Form 
 */
export const RadioButtonUncheckedIcon = RadioboxBlankIcon;
export default RadioButtonUncheckedIcon